import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    JsonpClientBackend,
} from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { Subject } from "rxjs";
import { NodoArbolMenu } from "src/app/asistente-en-linea/components/asistencia-menu-arbol/models/nodo-arbol-menu";
import { EditingMode } from "../models/editingMode";
import { NodeType } from '../../asistente-en-linea/components/asistencia-menu-arbol/models/node-type';
import { Nodo } from "src/app/asistente-en-linea/models/Nodo";

// const endpoint = environment.apiMenuArbolUrl;
// const endpointFaq = environment.apiMenuFaqUrl;
const endpoint = environment.apiBaseUrl + '/admin/menu/arbol';
const endpointFaq = environment.apiBaseUrl + '/admin/menu/faq';

const httpOptions = {
    headers: new HttpHeaders({
        "Content-Type": "application/json",
    }),
};

@Injectable({
    providedIn: "root",
})
export class ConfigService {
    editingDataSubject: { node: NodoArbolMenu, mode: EditingMode, cantidadNodos: number, numberOfSiblingsArr: number[], numberOfSiblingsArrCreation: number[] };
    editingDataSubject$: Subject<{ node: NodoArbolMenu, mode: EditingMode, cantidadNodos: number, numberOfSiblingsArr: number[], numberOfSiblingsArrCreation: number[] }>
    defaultIdMenu: string;
    public faqsGlobal: any[] = [];

    constructor(private httpClient: HttpClient) {
        this.editingDataSubject = { node: undefined, mode: undefined, cantidadNodos: undefined, numberOfSiblingsArr: [], numberOfSiblingsArrCreation: [] }
        this.editingDataSubject$ = new Subject<{ node: NodoArbolMenu, mode: EditingMode, cantidadNodos: number, numberOfSiblingsArr: number[], numberOfSiblingsArrCreation: number[] }>();
        this.defaultIdMenu = "1";
    }

    private extractData(res: Response) {
        const body = res;
        return body || {};
    }

    updateEditingData(data: {
        faqsGlobal: any[]; node: NodoArbolMenu, mode: EditingMode, cantidadNodos: number, numberOfSiblingsArr: number[], numberOfSiblingsArrCreation: number[] 
}) {
        this.editingDataSubject = data;
        if (data.faqsGlobal) {
            this.faqsGlobal = data.faqsGlobal;
        }
        this.editingDataSubject$.next(data);
    }

    getEditingDataSubject$() {
        return this.editingDataSubject$.asObservable();
    }

    //HTTP
    //Cargar el árbol y las preguntas frecuentes con sus ids.
    loadConfiglTree(id_menu, idNodo) {
        const idMenu = id_menu ? id_menu : this.defaultIdMenu;
        if (!idNodo || idNodo == undefined) {
            idNodo = "-1";
        }
        return this.httpClient.get<any>(endpoint + `/display/${idMenu}/${idNodo}`).pipe(map(this.extractData));
    }



    updateNode(id, name, answer, assistanceId, order, updateUser, areaCode) {
        const params = {
            idNodo: id,
            pregunta: name,
            respuesta: answer,
            idAsistencia: assistanceId,
            orden: order,
            userName: updateUser,
            codigoTemaDestinatario: areaCode && areaCode != '-1' ? areaCode : ''
        }
        return this.httpClient.post(`${endpoint}/node/update`, params)
    }





    crearNodo(nodo: Nodo) {
        const params = {
            idAsistente: nodo.idAsistente,
            tipoNodo: nodo.tipoNodo,
            idPadre: nodo.idPadre,
            nombre: nodo.nombre,
            respuesta: nodo.respuesta,
            idAsistenteAccion: nodo.idAsistenteAccion,
            orden: nodo.orden,
            usuarioActualizacion: nodo.usuarioActualizacion,
            temaMotivo: nodo.temaMotivo,
            tipoFormulario: nodo.tipoFormulario,
            idDestinatario: nodo.idDestinatario
        }
        return this.httpClient.post(`${endpoint}/node/add`, params)
    }

    addUpdateNodes(menuId, username, nodoCrearActualizar: Partial<Nodo>, nodosActualizar: Partial<Nodo>[]) {
        // if (nodoCrearActualizar && nodoCrearActualizar.tipoNodo == NodeType.Action && !nodoCrearActualizar.esFormulario) {
        //     nodoCrearActualizar.codigoTemaDestinatario = '';
        // }

        const params = {
            idMenu: menuId,
            userName: username,
            nodoCrearActualizar: nodoCrearActualizar,
            nodosActualizar: nodosActualizar
        }
        return this.httpClient.post(`${endpoint}/node/addUpdateNodes`, params)
    }

    deleteUpdateNodes(menuId, idNodoEliminar, username, nodosActualizar) {
       // debugger
        const params = {
            idMenu: menuId,
            idNodoEliminar: idNodoEliminar,
            userName: username,
            nodosActualizar: nodosActualizar
        }
        return this.httpClient.post(`${endpoint}/node/deleteUpdateNodes`, params)
    }


    createFaqNode(menuId, nodeId, parentId, updateUser) {
        const params = {
            idNodo: nodeId,
            idNodoPadre: parentId,
            usuarioModificador: updateUser
        }
        return this.httpClient.post(`${endpointFaq}/add`, params);

    }

    deleteTreeNode(id, updateUser) {
        const params = {
            id
        }
        return this.httpClient.post(`${endpoint}/node/delete/${id}/${updateUser}`, params);
    }

    deleteFaqNode(id, updateUser) {
        const params = {
            id
        }
        return this.httpClient.post(`${endpointFaq}/delete/${id}/${updateUser}`, params);
    }


    loadPossibleFAQs(id_menu) {
        const idMenu = id_menu ? id_menu : this.defaultIdMenu;
        return this.httpClient.get<any>(`${endpointFaq}/retrieve/candidates/${idMenu}`).pipe(map(this.extractData));
    }



}
